import { socialApiClient } from '@/shared/api-client/social-api-client';
import type { QueryProgress } from './types';

export const getQueryProgress = async (
  workspaceId: string,
  queryId: string,
): Promise<QueryProgress[]> => {
  const response = await socialApiClient.get(
    `workspaces/${workspaceId}/queries/${queryId}/scraping_status`,
  );
  return await response.json();
};

export const deleteQuery = async ({
  workspaceId,
  queryId,
}: {
  workspaceId: string;
  queryId: string;
}): Promise<void> => {
  await socialApiClient.delete(`workspaces/${workspaceId}/queries/${queryId}`);
};
